var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.meta && _vm.meta.total > _vm.meta.per_page)?_c('b-pagination',_vm._g({attrs:{"size":"sm","value":_vm.meta.current_page,"per-page":_vm.meta.per_page,"total-rows":_vm.meta.total,"align":_vm.align}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }